module.exports = __webpack_public_path__ + "static/media/tv1.aa4bb54f.jpg";